import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import Error from 'components/DriverMap/Error/component';

const enhance = compose(withTranslation('DriverMapError'));

export default enhance(Error);
